"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnManager = void 0;
class ColumnManager {
    constructor(columns) {
        this.tree = this.clone(columns);
    }
    clone(nodes) {
        return nodes.map(node => {
            var _a, _b;
            return (Object.assign(Object.assign({}, node), { checked: (_a = node.checked) !== null && _a !== void 0 ? _a : false, filterable: (_b = node.filterable) !== null && _b !== void 0 ? _b : false, children: node.children ? this.clone(node.children) : undefined }));
        });
    }
    addRootTree(s) {
        this.tree.push(s);
    }
    getTree() {
        return this.tree;
    }
    toggle(key, checked) {
        this.updateNode(this.tree, key, checked);
        this.updateParentStates(this.tree);
    }
    toggleAll(checked) {
        this.tree.forEach((n) => {
            this.toggle(n.key, checked);
        });
    }
    updateParentStates(nodes) {
        for (const node of nodes) {
            if (node.children) {
                this.updateParentStates(node.children);
                const allChecked = node.children.every(child => child.checked);
                const noneChecked = node.children.every(child => !child.checked);
                if (allChecked) {
                    node.checked = true;
                }
                else if (noneChecked) {
                    node.checked = false;
                }
                else {
                    node.checked = false; // o usa null si implementas tri-state
                }
            }
        }
    }
    updateNode(nodes, key, checked) {
        for (const node of nodes) {
            if (node.key === key) {
                node.checked = checked;
                this.setChildrenChecked(node, checked);
                return true;
            }
            if (node.children) {
                const found = this.updateNode(node.children, key, checked);
                if (found) {
                    return true;
                }
            }
        }
        return false;
    }
    setChildrenCheckedByKey(nodeKey, checked) {
        this.updateNode(this.tree, nodeKey, checked);
    }
    setChildrenChecked(node, checked) {
        if (node.children) {
            for (const child of node.children) {
                child.checked = checked;
                this.setChildrenChecked(child, checked);
            }
        }
    }
    getActiveKeys() {
        const keys = [];
        this.collectCheckedKeys(this.tree, keys);
        return keys;
    }
    collectCheckedKeys(nodes, keys) {
        for (const node of nodes) {
            if (node.checked) {
                keys.push(node.key);
            }
            if (node.children) {
                this.collectCheckedKeys(node.children, keys);
            }
        }
    }
}
exports.ColumnManager = ColumnManager;
